import React from "react";
import classnames from "classnames";
import useStyles from "./FmButton.style";
import { FmLoader } from "../FmLoader";
import { FmIcon } from "../FmIcon";

type typeType = "button" | "reset" | "submit";
type widthType = "mapButton" | "regular" | "small" | "smallest" | "fullWidth" | "mobileFullWidth" | "whiteButton";

interface FmButtonProps {
  children: React.ReactNode;
  type?: typeType;
  fullWidth?: widthType;
  onClick?: any;
  disabled?: boolean;
  loading?: boolean;
  icon?: string;
}

const FmButton = ({ children, type, fullWidth, onClick, disabled = false, loading = false, icon }: FmButtonProps) => {
  const classes = useStyles();

  const buttonWidth =
    fullWidth === "regular"
      ? classes.regularButton
      : fullWidth === "small"
        ? classes.smallButton
        : fullWidth === "smallest"
          ? classes.smallestButton
          : fullWidth == "mobileFullWidth"
            ? classes.mobileFullWidth
            : fullWidth === "mapButton"
              ? classes.mapButton
              : fullWidth === "whiteButton"
                ? classes.whiteButton
                : "";

  const buttonClass = classnames(classes.button_container, buttonWidth, {
    [classes.disabled]: disabled,
  });

  return (
    <button className={buttonClass} type={type} disabled={disabled || loading} onClick={() => !disabled && !loading && onClick && onClick()}>
      {!icon && children}

      {icon && (
        <div style={{ display: "flex", gap: 10 }}>
          {!loading && icon && <FmIcon className={classes.btnIcon} url={icon} />}
          {children}
        </div>
      )}

      {loading && <FmLoader variant={"secondary"} size={"verySmall"} className={classes.loader} />}
    </button>
  );
};

export default FmButton;
